import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getWpPrefix, getWpNumber, getContractorRole } from "../utils/adrUtilsV3";
import { MAX_COLUMNS } from "../utils/adrUtilsV3";
import { ADR_REVIEW } from "../../../_constants/actionConstants";
import { adrSections } from "../../../_constants/docSections";
import { AdrCorrectionCommentsV3 } from "./AdrCorrectionCommentsV3";
import { AdrReviewWpDescHelpV3 } from "./AdrReviewWpDescHelpV3";

export function AdrReviewLaborSetV3(props) {
  const { tabId, wpSortOrder } = props;
  const adr = useSelector((state) => state.adr.openAdrs[tabId] || null);
  const projContractorList = useSelector(
    (state) => state.contractors.projContractorLists[adr.projectId] || null
  );
  const projLaborList = useSelector(
    (state) => state.labors.projLaborLists[adr.projectId] || null
  );
  const tradeList = useSelector((state) => state.feederLists.tradeList || null);
  const projItemList = useSelector(
    (state) => state.bidItems.projItemLists[adr.projectId] || null
  );
  const projCcoList = useSelector(
    (state) => state.ccos.projCcoLists[adr.projectId] || null
  );
  const projPendingIssueList = useSelector(
    (state) => state.pendingIssues.projPendingIssueLists[adr.projectId] || null
  );

  const [showWpHelp, toggleWpHelp] = useState(false);

  const filteredCcs = adr
    ? (adr.correctionComments || []).filter(
        (cc) => cc.section === adrSections.ADR_SECTION_LABOR
      )
    : [];

  const hasCorrectionComment = (fieldInfoToLookup) => {
    const ccBase = (adr.correctionComments || []).filter(
      (c) =>
        c.section === adrSections.ADR_SECTION_LABOR &&
        c.fieldInfo &&
        c.fieldInfo.laborId === fieldInfoToLookup.laborId &&
        c.fieldInfo.tradeId === fieldInfoToLookup.tradeId
    );
    const cc = ccBase.find((c) =>
      fieldInfoToLookup.name === "hours"
        ? c.fieldInfo.workPerformedId === fieldInfoToLookup.workPerformedId
        : c.fieldInfo.name === fieldInfoToLookup.name
    );
    return cc ? true : false;
  };

  const renderLaborThead = () => {
    const wpLength = (wpSortOrder || []).length;
    let th = [];
    let i = 0;
    for (i = 0; i < wpLength; i++) {
      const wp = adr.workPerformedClient[wpSortOrder[i].wpTabId];
      th.push(
        <th
          key={`labWpThKey_${i}`}
          className="th-labor-hours review align-bottom border-right pointer-cursor"
          onClick={() => toggleWpHelp(!showWpHelp)}
        >
          {wp.isIdle && (
            <React.Fragment>
              <small>
                <span className="text-danger"> (idle)</span>
              </small>
              <br />
            </React.Fragment>
          )}
          <small>{getWpPrefix(wp)}</small>{" "}
          {getWpNumber(wp, projItemList, projCcoList, projPendingIssueList)}
        </th>
      );
    }
    if (i < MAX_COLUMNS) {
      for (let remCol = wpLength; remCol < MAX_COLUMNS; remCol++) {
        th.push(
          <th
            key={`labWpThKey_${remCol}`}
            className="th-labor-hours review border-right"
          />
        );
      }
    }
    return (
      <thead>
        <tr className="bg-lightgray">
          <th className="th-labor-contractor review align-bottom border-right">
            Contractor
          </th>
          <th className="th-labor-laborName review align-bottom border-right">Name</th>
          <th className="th-labor-trade review align-bottom border-right">Trade</th>
          <th className="td-labor-time-type review border-right" />
          {th}
          <th className="th-laborRemarks align-bottom">Remarks</th>
        </tr>
      </thead>
    );
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12">
          <h4>Work Performed Hours</h4>
          <h5 className="text-muted">Labor</h5>
        </div>
      </div>
      {showWpHelp && (
        <AdrReviewWpDescHelpV3
          toggleWpHelp={toggleWpHelp}
          showWpHelp={showWpHelp}
          tabId={tabId}
          wpSortOrder={wpSortOrder || []}
          {...props}
        />
      )}
      <div className="row">
        <div className="col-lg-9">
          {adr &&
          Object.values(adr.laborSetClient).filter(
            (l) => l.contractorId && l.laborId && l.tradeId
          ).length === 0 ? (
            <div className="row">
              <div className="col-12">No labor to report this day.</div>
            </div>
          ) : (
            <table className="table-labor review border-top border-bottom">
              {renderLaborThead()}
              <tbody>
                {adr.laborSetOrder.map((lsrKey) => {
                  const lsr = adr.laborSetClient[lsrKey] || null;
                  if (lsr && lsr.laborId && lsr.tradeId) {
                    const hasOt = Object.values(lsr.laborHours).some(
                      (lh) => lh.otHours > 0
                    );
                    return (
                      <React.Fragment key={`labWpOtFragKey_${lsrKey}`}>
                        <AdrReviewLaborSetRowV3
                          {...props}
                          lsrKey={lsrKey}
                          hasOt={hasOt}
                          adr={adr}
                          wpSortOrder={wpSortOrder || []}
                          projLaborList={projLaborList}
                          projContractorList={projContractorList}
                          tradeList={tradeList}
                          hasCorrectionComment={hasCorrectionComment}
                        />
                        {hasOt && (
                          <AdrReviewLaborSetOtRowV3
                            {...props}
                            lsrKey={lsrKey}
                            adr={adr}
                            wpSortOrder={wpSortOrder || []}
                            projLaborList={projLaborList}
                            tradeList={tradeList}
                            hasCorrectionComment={hasCorrectionComment}
                          />
                        )}
                      </React.Fragment>
                    );
                  }
                  return null;
                })}
              </tbody>
            </table>
          )}
        </div>
        <div className="col-lg-3 col-md-12 border-left">
          <AdrCorrectionCommentsV3
            section={adrSections.ADR_SECTION_LABOR}
            correctionComments={filteredCcs}
            tabId={tabId}
            {...props}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

function AdrReviewLaborSetRowV3(props) {
  const {
    tabId,
    wpSortOrder,
    lsrKey,
    hasOt,
    reviewerInitials,
    adr,
    projContractorList,
    projLaborList,
    tradeList,
    hasCorrectionComment,
    userIsReviewer,
  } = props;
  const dispatch = useDispatch();
  const projItemList = useSelector(
    (state) => state.bidItems.projItemLists[adr.projectId] || null
  );
  const projCcoList = useSelector(
    (state) => state.ccos.projCcoLists[adr.projectId] || null
  );
  const projPendingIssueList = useSelector(
    (state) => state.pendingIssues.projPendingIssueLists[adr.projectId] || null
  );
  const user = useSelector((state) => state.authentication.user || null);

  const handleClick_field = (fieldInfo) => (e) => {
    e.preventDefault();
    if (!hasCorrectionComment(fieldInfo) && adr.isInReview && userIsReviewer && user)
      dispatch({
        type: ADR_REVIEW.CORRECTION_COMMENTS.ADD_BLANK,
        tabId,
        byUserId: user.userId,
        section: adrSections.ADR_SECTION_LABOR,
        fieldInfo,
      });
  };

  const lsr = adr.laborSetClient[lsrKey];

  const labor = (projLaborList || []).find((l) => l.laborId === lsr.laborId) || null;
  const contractor = labor
    ? (projContractorList || []).find((c) => c.contractorId === labor.contractorId) ||
      null
    : null;
  const trade = (tradeList || []).find((t) => t.tradeId === lsr.tradeId) || null;
  const laborName = labor ? labor.fullName : "(name N/A)";
  const tradeTitle = trade ? trade.title : "(trade N/A)";

  const metadata = {
    lsrKey,
    laborId: lsr.laborId,
    tradeId: lsr.tradeId,
    workPerformedId: null,
    reviewerInitials,
  };

  const nameInfo = {
    ...metadata,
    name: "laborName",
    value: laborName,
    label: "Labor Name",
    subLabel: `${laborName}`,
  };

  const tradeInfo = {
    ...metadata,
    name: "trade",
    value: tradeTitle,
    label: "Trade",
    subLabel: `${tradeTitle} (for ${laborName})`,
  };

  const remarksInfo = {
    ...metadata,
    name: "laborRemarks",
    value: lsr.remarks.remarks || "",
    label: "Labor Remarks",
    subLabel: `For ${laborName}`,
  };

  let td = [];
  td.push(
    <td
      key={`labWpTdKey_contractor_${lsrKey}`}
      className="td-labor-contractor review align-top border-right"
      rowSpan={hasOt ? "2" : "1"}
    >
      {contractor && (
        <React.Fragment>
          {contractor.abbreviation}{" "}
          <small className="text-muted">({getContractorRole(contractor)})</small>
        </React.Fragment>
      )}
    </td>
  );
  td.push(
    <td
      key={`labWpTdKey_labor_${lsrKey}`}
      className="td-labor-name review align-top border-right"
      rowSpan={hasOt ? "2" : "1"}
    >
      <div
        className={`${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
          hasCorrectionComment(nameInfo) ? "has-comment" : ""
        }`}
        onClick={handleClick_field(nameInfo)}
      >
        {laborName}
      </div>
    </td>
  );
  td.push(
    <td
      key={`labWpTdKey_trade_${lsrKey}`}
      className="td-labor-trade review align-top border-right"
      rowSpan={hasOt ? "2" : "1"}
    >
      <div
        className={`${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
          hasCorrectionComment(tradeInfo) ? "has-comment" : ""
        }`}
        onClick={handleClick_field(tradeInfo)}
      >
        {tradeTitle}
      </div>
    </td>
  );
  td.push(
    <td
      key={`labWpTdKey_laborTimeType_${lsrKey}`}
      className="td-labor-time-type review align-top border-right"
    >
      <small>
        <span className="badge badge-info my-auto">RT</span>
      </small>
    </td>
  );

  let i = 0;
  for (i = 0; i < wpSortOrder.length; i++) {
    const wp = adr.workPerformedClient[wpSortOrder[i].wpTabId];
    const hours = wp.isIdle
      ? "-"
      : lsr.laborHours[wpSortOrder[i].wpTabId].regHours || "0";
    const hourInfo = {
      ...metadata,
      workPerformedId: wp.workPerformedId,
      name: "hours",
      value: hours,
      label: "Hours (RT)",
      subLabel: `${hours} for ${laborName} (${tradeTitle}), on ${getWpPrefix(
        wp
      )}${getWpNumber(wp, projItemList, projCcoList, projPendingIssueList)}`,
    };
    td.push(
      <td
        key={`labWpTdKey_labHours_${i}_${lsrKey}`}
        className="td-labor-hours review align-top text-right border-right"
      >
        <div
          className={`${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
            hasCorrectionComment(hourInfo) ? "has-comment" : ""
          }`}
          onClick={handleClick_field(hourInfo)}
        >
          {hours}
        </div>
      </td>
    );
  }
  if (i < MAX_COLUMNS) {
    for (let remCol = i; remCol < MAX_COLUMNS; remCol++) {
      td.push(
        <td
          key={`labWpTdKey_labHours_${remCol}_${lsrKey}`}
          className="td-labor-hours review align-top text-right border-right"
        />
      );
    }
  }
  td.push(
    <td
      key={`labWpTdKey_remarks_${lsrKey}`}
      className="td-labor-remarks review align-top"
      rowSpan={hasOt ? "2" : "1"}
    >
      <div
        className={`${
          lsr.remarks.remarks
            ? `${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
                hasCorrectionComment(remarksInfo) ? "has-comment" : ""
              }`
            : ""
        }`}
        onClick={handleClick_field(remarksInfo)}
      >
        {lsr.remarks.remarks || ""}
      </div>
    </td>
  );
  return (
    <tr className="border-top" key={`labWpTrKey_${lsrKey}`}>
      {td}
    </tr>
  );
}

function AdrReviewLaborSetOtRowV3(props) {
  const {
    tabId,
    lsrKey,
    wpSortOrder,
    reviewerInitials,
    adr,
    projLaborList,
    tradeList,
    hasCorrectionComment,
    userIsReviewer,
  } = props;
  const dispatch = useDispatch();
  const projItemList = useSelector(
    (state) => state.bidItems.projItemLists[adr.projectId] || null
  );
  const projCcoList = useSelector(
    (state) => state.ccos.projCcoLists[adr.projectId] || null
  );
  const projPendingIssueList = useSelector(
    (state) => state.pendingIssues.projPendingIssueLists[adr.projectId] || null
  );
  const user = useSelector((state) => state.authentication.user || null);

  const lsr = adr.laborSetClient[lsrKey];

  const handleClick_field = (fieldInfo) => (e) => {
    e.preventDefault();
    if (!hasCorrectionComment(fieldInfo) && user)
      dispatch({
        type: ADR_REVIEW.CORRECTION_COMMENTS.ADD_BLANK,
        tabId,
        byUserId: user.userId,
        section: adrSections.ADR_SECTION_LABOR,
        fieldInfo,
      });
  };

  const labor = useMemo(
    () => (projLaborList || []).find((l) => l.laborId === lsr.laborId) || null,
    [projLaborList, lsr]
  );
  const trade = useMemo(
    () => (tradeList || []).find((t) => t.tradeId === lsr.tradeId) || null,
    [tradeList, lsr]
  );
  const laborName = labor ? labor.fullName : "(name N/A)";
  const tradeTitle = trade ? trade.title : "(trade N/A)";

  const metadata = {
    lsrKey,
    laborId: lsr.laborId,
    tradeId: lsr.tradeId,
    workPerformedId: null,
    reviewerInitials,
  };

  let td = [];
  td.push(
    <td
      key={`labWpOtTdKey_laborTimeType_${lsrKey}`}
      className="td-labor-time-type review align-top border-right"
    >
      <small>
        <span className="badge badge-warning my-auto">OT</span>
      </small>
    </td>
  );
  let i = 0;
  for (i = 0; i < wpSortOrder.length; i++) {
    const wp = adr.workPerformedClient[wpSortOrder[i].wpTabId];
    const hours = wp.isIdle ? "-" : lsr.laborHours[wpSortOrder[i].wpTabId].otHours || "0";
    const hourInfo = {
      ...metadata,
      workPerformedId: wp.workPerformedId,
      name: "hours",
      value: hours,
      label: "Hours (OT)",
      subLabel: `${hours} for ${laborName} (${tradeTitle}), on ${getWpPrefix(
        wp
      )}${getWpNumber(wp, projItemList, projCcoList, projPendingIssueList)}`,
    };
    td.push(
      <td
        key={`labWpOtTdKey_labHours_${i}_${lsrKey}`}
        className="td-labor-hours review align-top text-right border-right"
      >
        <div
          className={`${userIsReviewer && adr.isInReview ? "reviewable-item" : ""} ${
            hasCorrectionComment(hourInfo) ? "has-comment" : ""
          }`}
          onClick={handleClick_field(hourInfo)}
        >
          {hours}
        </div>
      </td>
    );
  }
  if (i < MAX_COLUMNS) {
    for (let remCol = i; remCol < MAX_COLUMNS; remCol++) {
      td.push(
        <td
          key={`labWpOtTdKey_labHours_${remCol}_${lsrKey}`}
          className="td-labor-hours review align-top text-right border-right"
        />
      );
    }
  }
  return (
    <tr className="border-top" key={`labWpOtTrKey_${lsrKey}`}>
      {td}
    </tr>
  );
}
